import type { UserProfileDto } from '../../../domain/contracts/api.contracts';
import { TierLevel } from '../../../domain/enums/TierLevel';
import { useTranslation } from '../../../application/hooks/useTranslation';
import { Card } from '../ui/Card';

/** W04 — nominee tiles. L1 only: agents/executives (L2–L6) never see nominee data, regardless of payload. */
export function NomineeCard({ user }: { user: Pick<UserProfileDto, 'tier' | 'nominee'> }) {
  const { t } = useTranslation();
  if (user.tier !== TierLevel.L1) return null;
  const n = user.nominee;
  return (
    <Card title={t('profile.nominee')}>
      {n ? (
        <dl className="kv" data-testid="nominee-card">
          <dt>{t('profile.nomineeName')}</dt>
          <dd style={{ fontWeight: 700, color: '#14251c' }}>{n.fullName}</dd>
          <dt>{t('profile.relation')}</dt>
          <dd>{n.relation}</dd>
          <dt>{t('profile.nomineeNid')}</dt>
          <dd className="tabular">{n.nidMasked}</dd>
        </dl>
      ) : (
        <p className="muted" data-testid="nominee-empty">
          {t('profile.notOnRecord')}
        </p>
      )}
    </Card>
  );
}
